const singleNavItems = [
	{ icon: 'dashboard', title: 'Dashboard', link: '/dashboard', permission: 'view_dashboard' },
	{ icon: 'view_headline', title: 'Data Entries', link: '/aids', permission: 'view_aids' },
	{ icon: 'today', title: 'Events', link: '/events', permission: 'view_events' },
	{ icon: 'location_on', title: 'Locations', link: '/locations', permission: 'view_locations' },
	{ icon: 'map', title: 'States', link: '/states', permission: 'view_states' },
	{ icon: 'layers', title: 'Partners', link: '/agencies', permission: 'view_agencies' },
	{ icon: 'people', title: 'Beneficiaries', link: '/beneficiaries', permission: 'view_beneficiaries' },
	{ icon: 'widgets', title: 'Sectors', link: '/sectors', permission: 'view_sectors' },
	{ icon: 'category', title: 'Categories', link: '/categories', permission: 'view_categories' }
]

const analyticsNavItems = [
	{ icon: 'assessment', title: 'Graphs', link: '/analytics/graphs', permission: 'view_analytics' },
	{ icon: 'map', title: 'Maps', link: '/analytics/maps', permission: 'view_analytics' }
]

const userNavItems = [
	{ icon: 'group_add', title: 'Admins', link: '/users/admins', permission: 'view_admins' },
	{ icon: 'group_add', title: 'SEMA Staff', link: '/users/agents/state', permission: 'view_state_agents' },
	{ icon: 'group_add', title: 'Partner Staff', link: '/users/agents/agency', permission: 'view_agency_agents' }
]

export { singleNavItems, analyticsNavItems, userNavItems }
